<!--Add class "loading" to activate the loader-->
<div [ngClass]="{loading: (showLoader$ | async)}" class="page_loader">
    <div class="loader_content">
      <img alt="Page Loader" class="loaderImage" src="./assets/icons/bars.svg">
      <p class="font-md">loading...</p>
    </div>
  </div>
  